import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { sortBy } from 'lodash';

import Education from './Education';

const FINISH_DATE_KEY = 'finishDate';

class Educations extends Component {
  render() {
    const {
      educations,
      onEdit,
      searchTerms,
    } = this.props;

    const sortedEducations = sortBy(educations, FINISH_DATE_KEY).reverse();

    return (
      <Fragment>
        { sortedEducations.map((education, index) => {
          const {
            course,
            finishDate,
            id,
            institution,
            level,
            levelLabel,
            startDate,
          } = education;

          return (
            <Education
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              course={course}
              finishDate={finishDate}
              id={id}
              institution={institution}
              level={level}
              levelLabel={levelLabel}
              onEdit={onEdit}
              searchTerms={searchTerms}
              startDate={startDate}
            />
          );
        })}
      </Fragment>
    );
  }
}

Educations.propTypes = {
  educations: PropTypes.arrayOf(PropTypes.object),
  onEdit: PropTypes.func,
  searchTerms: PropTypes.arrayOf(PropTypes.string),
};

Educations.defaultProps = {
  educations: [],
  searchTerms: [],
  onEdit: null,
};

export default Educations;
